import { ApiTagTypes, innovorderApi } from '../index';
import { ApiRequest, ApiResponse } from '../request.types';
import {
    GetModulesPayload,
    GetModuleTpePayload,
    Module,
    ModuleTpe,
    GetLoyaltyConfigPayload,
    LoyaltyConfig,
    DeleteLoyaltyConfigPayload,
    CreateLoyaltyConfigPayload,
    UpdateLoyaltyConfigPayload,
    LoyaltyProgram,
    SplioSubscription,
    ModuleNepting,
} from './modules.type';

const modulesApi = innovorderApi.injectEndpoints({
    endpoints: (build) => ({
        getModuleStripes: build.query<Module, ApiRequest<GetModulesPayload>>({
            query: ({ restaurantId, token }) => ({
                url: `/module_stripes/restaurant/${restaurantId}`,
                method: 'GET',
                headers: {
                    authorization: `Bearer ${token}`,
                },
            }),
            providesTags: [],
            transformResponse: (response: ApiResponse<Module>) => response.data,
            extraOptions: { maxRetries: 3 },
        }),
        getModuleIngenico: build.query<Module, ApiRequest<GetModulesPayload>>({
            query: ({ restaurantId, token }) => ({
                url: `/modules_ingenico/restaurant/${restaurantId}`,
                method: 'GET',
                headers: {
                    authorization: `Bearer ${token}`,
                },
            }),
            providesTags: [],
            transformResponse: (response: ApiResponse<Module>) => response.data,
            extraOptions: { maxRetries: 3 },
        }),
        getModulePaygreen: build.query<Module, ApiRequest<GetModulesPayload>>({
            query: ({ restaurantId, token }) => ({
                url: `/module_paygreens/restaurant/${restaurantId}`,
                method: 'GET',
                headers: {
                    authorization: `Bearer ${token}`,
                },
            }),
            providesTags: [],
            transformResponse: (response: ApiResponse<Module>) => response.data,
            extraOptions: { maxRetries: 3 },
        }),
        getModuleNepting: build.query<ModuleNepting, ApiRequest<GetModulesPayload>>({
            query: ({ restaurantId, token }) => ({
                url: `/module_nepting/restaurants/${restaurantId}`,
                method: 'GET',
                headers: {
                    authorization: `Bearer ${token}`,
                },
            }),
            providesTags: [],
            transformResponse: (response: ApiResponse<ModuleNepting>) => response.data,
            extraOptions: { maxRetries: 3 },
        }),
        getModuleIngenicoTpe: build.query<ModuleTpe[], ApiRequest<GetModuleTpePayload>>({
            query: ({ moduleId, token }) => ({
                url: `/ingenico_tpe/module_ingenico/${moduleId}`,
                method: 'GET',
                headers: {
                    authorization: `Bearer ${token}`,
                },
            }),
            providesTags: [],
            transformResponse: (response: ApiResponse<ModuleTpe[]>) => response.data,
            extraOptions: { maxRetries: 3 },
        }),
        getLoyaltyConfig: build.query<LoyaltyConfig, ApiRequest<GetLoyaltyConfigPayload>>({
            query: ({ restaurantId, token }) => ({
                url: `v1/loyalty/restaurants/${restaurantId}/config`,
                method: 'GET',
                headers: { authorization: `Bearer ${token}` },
            }),
            providesTags: [ApiTagTypes.LoyaltyConfig],
            transformResponse: (response: ApiResponse<LoyaltyConfig>) => response.data,
            extraOptions: { maxRetries: 3 },
        }),
        deleteLoyaltyConfig: build.mutation<void, ApiRequest<DeleteLoyaltyConfigPayload>>({
            query: ({ restaurantId, token }) => ({
                url: `v1/loyalty/restaurants/${restaurantId}/config`,
                method: 'DELETE',
                headers: { authorization: `Bearer ${token}` },
            }),
            invalidatesTags: [ApiTagTypes.LoyaltyConfig],
        }),
        createLoyaltyConfig: build.mutation<void, ApiRequest<CreateLoyaltyConfigPayload>>({
            query: ({ restaurantId, token, ...payload }) => ({
                url: `v1/loyalty/restaurants/${restaurantId}/config`,
                method: 'PUT',
                body: payload,
                headers: { authorization: `Bearer ${token}` },
            }),
            invalidatesTags: [ApiTagTypes.LoyaltyConfig],
        }),
        updateLoyaltyConfig: build.mutation<void, ApiRequest<UpdateLoyaltyConfigPayload>>({
            query: ({ restaurantId, token, ...payload }) => ({
                url: `v1/loyalty/restaurants/${restaurantId}/config`,
                method: 'PUT',
                body: payload,
                headers: { authorization: `Bearer ${token}` },
            }),
            invalidatesTags: [ApiTagTypes.LoyaltyConfig],
        }),
        getLoyaltyPrograms: build.query<LoyaltyProgram[], ApiRequest<GetLoyaltyConfigPayload>>({
            query: ({ restaurantId, token }) => ({
                url: `v1/loyalty/restaurants/${restaurantId}/programs`,
                method: 'GET',
                headers: { authorization: `Bearer ${token}` },
            }),
            transformResponse: (response: ApiResponse<LoyaltyProgram[]>) => response.data,
            extraOptions: { maxRetries: 3 },
        }),
        getSplioSubscriptions: build.query<SplioSubscription[], ApiRequest<GetLoyaltyConfigPayload>>({
            query: ({ restaurantId, token }) => ({
                url: `module_splios/v2/restaurants/${restaurantId}/subscriptions`,
                method: 'GET',
                headers: { authorization: `Bearer ${token}` },
            }),
            transformResponse: (response: ApiResponse<SplioSubscription[]>) => response.data,
            extraOptions: { maxRetries: 3 },
        }),
    }),
});

export const {
    useGetModuleStripesQuery,
    useGetModuleIngenicoQuery,
    useGetModulePaygreenQuery,
    useGetModuleNeptingQuery,
    useLazyGetModuleIngenicoTpeQuery,
    useGetLoyaltyConfigQuery,
    useDeleteLoyaltyConfigMutation,
    useCreateLoyaltyConfigMutation,
    useUpdateLoyaltyConfigMutation,
    useLazyGetLoyaltyProgramsQuery,
    useLazyGetSplioSubscriptionsQuery,
    useGetSplioSubscriptionsQuery,
} = modulesApi;
